import {
  AnyAssetApplication,
  FormikNewFormValues,
  NewAsset,
} from '@mss/mss-component-library';
import { FormikProps } from 'formik';

export type CopyArgs<AssetType extends AnyAssetApplication> = {
  values: FormikNewFormValues<AssetType>;
  setFieldValue: FormikProps<AssetType>['setFieldValue'];
  subType?: { key: string; value: string };
  index: number;
  fieldName: string;
  isCustomField?: boolean;
};

export function copyToOtherAssets<AssetType extends NewAsset>({
  values,
  setFieldValue,
  subType,
  index,
  fieldName,
  isCustomField,
}: CopyArgs<AssetType>) {
  return () => {
    const valueToCopy = isCustomField
      ? values.assets[index].values.custom_field_values[fieldName]
      : values.assets[index].values[fieldName as keyof AssetType];
    setFieldValue(
      'assets',
      values.assets.map(x => {
        const onlyOnSubType =
          // @ts-ignore
          subType && x.values[subType.key as keyof AssetType] === subType.value;
        const copyOnlyToOtherAssets = x.values.tempId !== index;
        const hasFieldOrIsCustomField = isCustomField || fieldName in x.values;
        if (
          copyOnlyToOtherAssets &&
          (onlyOnSubType ?? hasFieldOrIsCustomField)
        ) {
          return {
            ...x,
            values: {
              ...x.values,
              [isCustomField ? 'custom_field_values' : fieldName]: isCustomField
                ? {
                    ...x.values.custom_field_values,
                    [fieldName]: valueToCopy,
                  }
                : valueToCopy,
            },
          };
        }
        return x;
      })
    );
  };
}
